import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { useLocation } from 'react-router-dom';
import { api_menu_list } from '../../states/selector'
import { Button, ButtonGroup, Box, Typography, Grid } from '@mui/material'
import { TextField } from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import { format } from 'date-fns'
import { Sound, Movie, File, MultiLineBody } from '../../utils/util';

import { CONFIG } from '../../states/settings';


// TODO:
// 関数内に閉じ込めたいが、どうしてもuseEffect内で代入できなかった
let all_items = []

const Search = ()=>{
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)
  let [ matched_items, setMatchedItems ] = useState([])
  let [ results_num,   setResultsNum   ] = useState(0)
  let [ search_query, setSearchQuery ] = useState('')
  let location = useLocation()

  let partial_word = (word, q) => {
    let range = 25
    let p = word.indexOf(q)

    if (p < 0){ return '' }

    let suffix = ' __', prefix = '__ '
    let head = p - range
    if ( head < 0 ) {
      head = 0
      prefix = ''
    }
    return prefix + word.substr(head, range*2) + suffix
  }

  // ハイライト機能
  let highlightText = (text, query) => {
    if (!query || query.trim() === '') return text;
    
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => {
      if (regex.test(part)) {
        return <span key={index} className="search-highlight">{part}</span>;
      }
      return part;
    });
  }

  // 検索実行関数（共通化）
  let performSearch = (query) => {
    if (!query || query.trim() === '') {
      setMatchedItems([])
      setResultsNum(0)
      return
    }

    let filterd_items = []

    all_items.forEach(category_item => {
      let z = category_item.messages.filter(line=>{
        let regex = new RegExp(query,'ig')
        return line.title.match(regex) || line.body.match(regex)
      })

      z.forEach(v=>{
        v.partial = partial_word(v.body, query)
        v.name = category_item.name
        filterd_items.push(v)
      })
    })

    setResultsNum(filterd_items.length)
    setMatchedItems(filterd_items)
  }

  let onChange = e => {
    let q = e.target.value
    setSearchQuery(q)
    performSearch(q)
  }

  let SearchResults = ()=>{
    return (
      <Box className='wrapper' sx={{
        '@media (max-width: 900px)':{
          padding: 2
        },
        padding: 3
      }}>
        <Grid container spacing={2}>
          { matched_items.map((v, index)=>{
            return (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} key={`${v.name}-${v.id}-${index}`}>
                <Box
                  className={`item_wrapper ${v.is_emergency ? 'emergency' : ''}`}
                  pt='.7rem' pr='.7rem' pl='.7rem' pb='1.4rem'
                  sx={{
                    boxShadow: 2, 
                    bgcolor: '#fafafa', 
                    alignItems: 'stretch',
                    borderRadius: 2,
                    border: '1px solid transparent',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 25px rgba(33, 150, 243, 0.2)',
                      border: '1px solid #2196f3',
                      '& .sender_name': {
                        color: '#1976d2',
                      },
                      '& .time_c1': {
                        color: '#1976d2',
                      },
                    }
                  }}
                >
                  <Link to={{
                    pathname: `${CONFIG.PAGE_ROOT_PATH}/${v.name}/items/${v.id}`,
                    state: {
                      from_url: location.pathname,
                      search_query: search_query,
                      scroll_position: window.scrollY
                    }
                  }} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography component="h4" variant="h6" fontWeight='600' mb='1rem' sx={{
                      lineHeight:'1.4',
                      cursor: 'pointer',
                      position: 'relative',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      backgroundColor: 'rgba(25, 118, 210, 0.05)',
                      border: '1px solid rgba(25, 118, 210, 0.2)',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        color: '#1976d2',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)',
                        border: '1px solid #1976d2',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                        '&::after': {
                          content: '"👆"',
                          position: 'absolute',
                          right: '8px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontSize: '14px',
                          opacity: 0.7
                        }
                      },
                      '&::before': {
                        content: '"🔍"',
                        marginRight: '8px',
                        fontSize: '16px'
                      }
                    }}>
                      【{v.name}】 {highlightText(v.title, search_query)}
                    </Typography>
                  </Link>

                  <Grid className='item_list_other' container mb='1.5rem'>
                    <p className='sender_name'>{v.sender_name}</p>
                    <time className='time_c1' dateTime={format(new Date(v.sent_at),'yyyy-MM-dd HH:mm')}>
                      {format(new Date(v.sent_at),'yyyy-MM-dd HH:mm')}
                    </time>
                  </Grid>

                  <div onClick={(e) => e.stopPropagation()}>
                    <Sound item={v.sound_file ? v.sound_file : (v.generated_sound_file ? v.generated_sound_file : null)} />
                  </div>

                  <Typography className='mabiku' component="p" variant="h7" mb='1.2rem' sx={{ 
                    fontSize: '.9rem',
                    lineHeight: '1.6'
                  }}>
                    {highlightText(v.body, search_query)}
                  </Typography>

                  <div onClick={(e) => e.stopPropagation()}>
                    <Movie item={v.movie_url} />
                    <File item={v.file} />
                  </div>
                </Box>
              </Grid>
            )
          }) }
        </Grid>
        
        {matched_items.length === 0 && (
          <Box textAlign="center" py={4}>
            <Typography variant="h6" color="text.secondary">
              検索結果がありません
            </Typography>
          </Box>
        )}
      </Box>
    )
  }

  let store = lines => {
    all_items = lines
  }


  useEffect(()=>{
    (async ()=>{
      try {
        let lines = []

        for (const menu of menu_list) {
          try {
            const url = CONFIG.API.INFO + menu.json_file.split('.')[0] + CONFIG.API.INFO_EX;
            const response = await fetch(url);
            
            if (!response.ok) {
              console.warn(`メニュー ${menu.group_name} のHTTPエラー:`, response.status, response.statusText);
              continue;
            }
            
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
              console.warn(`メニュー ${menu.group_name} のContent-Typeエラー:`, contentType);
              continue;
            }
            
            const json = await response.json();
            
            lines.push({
              ...json,
              name: menu.group_name
            });
          } catch (error) {
            console.warn(`メニュー ${menu.group_name} のデータ取得に失敗:`, error);
          }
        }

        store(lines)
        
        // 遷移元からの検索クエリを復元
        const restoredQuery = location.state?.search_query;
        if (restoredQuery && restoredQuery.trim() !== '') {
          setSearchQuery(restoredQuery);
          performSearch(restoredQuery);
          
          // スクロール位置を復元
          const scrollPosition = location.state?.scroll_position;
          if (scrollPosition) {
            setTimeout(() => {
              window.scrollTo(0, scrollPosition);
            }, 200); // 検索結果の描画を待つ
          }
        }
      } catch (error) {
        console.error('検索データの取得に失敗しました:', error);
      }
    })();
  }, [menu_list, location.state])

  return (
    <>
      <Box sx={{ textAlign:'center', padding:'20px 0' }}>
        <TextField sx={{ width:'80vw' }} label='検索ワード入力してください' margin='normal' value={search_query} onChange={ onChange }/>
        <Typography component="h5" variant="h7" fontWeight='300' sx={{ padding:'12px 0 0',fontSize:'1rem' }}>
          検索結果：<b>{ results_num }</b> 件
        </Typography>
      </Box>
      <SearchResults />
    </>
  )
}


export default Search
